<app-shared-loading *ngIf="loading"></app-shared-loading>
<div class="contentBox">
    <div class="center col-3">
        <div class="info-logo-container">
            <img src="{{ info.logo }}" class="payment_method_no_interactive __method_brands" alt="Logo PSE"/>
            <h2 class="ng-star-inserted">{{user}}</h2>
        </div>
    </div>
    <div class="col-7">
        <div class="methodInfo">
            <app-return-methods
              [itsMobileCtrl]="false"
              [unique]="this.transaction.ORDER_METHOD"
              (RT)="changeMethod()"></app-return-methods>
            <h1 *ngIf="notCRC(); else important_header" class="center">{{ 'transfer-bam-title' | translation | async }}</h1>
            <ng-template #important_header>
                <h1 class="center">{{ 'deposit-Title-Agent-nosucur' | translation | async }} {{ getActualRC() | translation | async }}</h1>
            </ng-template>
            <app-payment-expiration [expiration]="transaction.EXPIRATION"></app-payment-expiration>
            <div class="methodForm">
                <app-counter-item>
                    <p innerHTML="{{ 'deposit-RefPago-bam' | translation | async }}"></p>
                    <app-copy-to-clipboard [value]="currentConcept?.number" [idleEnable]="false"></app-copy-to-clipboard>
                </app-counter-item>
                <app-counter-item>
                    <p innerHTML="{{ 'deposit-RefPago-bam-name' | translation | async }}"></p>
                    <app-copy-to-clipboard [value]="'Payvalida Guatemala S.A'" [idleEnable]="false"></app-copy-to-clipboard>
                </app-counter-item>
                <div>
                    <p>{{ 'deposit-EmailInfo' | translation | async }}</p>
                    <form [formGroup]="emailForm" autocomplete="off">
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'forms-Email-Input' | translation | async }}</mat-label>
                            <input type="email" matInput name="email" placeholder="{{ 'forms-Email-Input' | translation | async }}"
                                maxlength="40" formControlName="email" />
                            <mat-error *ngIf=" !emailForm.valid && emailForm.get('email').touched">
                                <div *ngIf="emailForm.get('email').errors?.required"
                                    innerHTML="{{ 'forms-EmailRequired' | translation | async }}"></div>
                                <div *ngIf="emailForm.get('email').errors?.pattern">{{ 'forms-EmailInvalid' | translation | async }}
                                </div>
                            </mat-error>
                        </mat-form-field>
                        <br>
                        <app-privacy-conditions (formPrivacyUpdate)="formPrivacyUpdate($event)"></app-privacy-conditions>
                        <div class="captcha-container">
                            <re-captcha (resolved)="resolved($event)" [siteKey]="captchaKey"></re-captcha>
                        </div>
                    </form>
                </div>
                <div class="otherInfo">
                    <p innerHTML="{{ 'deposit-RefPago-bam-info-time' | translation | async }}"></p>
                </div>
            </div>
        </div>
        <app-buttons-bar [template]="template" [valid]="completedForms()"
            [nameCustom]="'Enviar'"
            (CUSTOM)="sendEmail()">
        </app-buttons-bar>
    </div>
</div>

